import { useEffect, useState } from "react";

import { Card } from "../../../components/Card";

import { api } from "../../../services/api";
import { AxiosError } from "axios";
import { AddButton } from "../../../components/atoms/Button/AddButton";
import { ButtonListButton } from "../../../components/organisms/ButtonListBox";
import { useNavigate } from "react-router-dom";
import { EditButton } from "../../../components/molecules/EditButton";
import { DeleteModal } from "../../../components/templates/DeleteModal";
import { useQuery } from "../../../hooks/query";
import { Table } from "../../../components/templates/Table";
import { useAuth } from "../../../hooks/auth";
import { checkPermission } from "../../../utils/checkPermission";

interface AccountPlanCategory {
  id: string;
  name: string;
  type: string;
  subtype: string;
}
interface Params {
  page: number;
  limit_per_page: number;
  search: string;
  order_column?: string;
  order_type?: string;
}
export function ListAccountPlanCategories() {
  const query = useQuery();
  const { user } = useAuth();

  const navigate = useNavigate();
  const [accountPlanCategories, setAccountPlanCategories] = useState<
    AccountPlanCategory[]
  >([]);
  const [loading, setLoading] = useState(false);

  const [total, setTotal] = useState<number>(0);
  const [defaultParams, setDefaultParams] = useState<Params>({
    limit_per_page: query.get("limit") ? Number(query.get("limit")) : 10,
    page: query.get("offset") ? Number(query.get("offset")) : 1,
    search: query.get("search") ?? "",
    order_column: query.get("order_column") ?? "",
    order_type: query.get("order_type") ?? "",
  });
  useEffect(() => {
    api
      .get(
        `accountPlanCategories/pagination?offset=${defaultParams.page}&limit=${defaultParams.limit_per_page}&search=${defaultParams.search}&order_column=${defaultParams.order_column}&order_type=${defaultParams.order_type}`
      )
      .then((response) => {
        setAccountPlanCategories(response.data.accountPlanCategories);
        setTotal(response.data.total);
        setLoading(true);
      })
      .catch((err: AxiosError) => {
        navigate(`/error/${err.response?.status}`);
      });
  }, [defaultParams, navigate]);
  return (
    <>
      <Card
        border="#216ca5"
        title="Contas"
        header={<AddButton link="/conta/cadastrar" />}
        body={
          <Table
            loading={loading}
            message="Buscando as contas"
            params={defaultParams}
            setDefaultParams={(params) => {
              setDefaultParams(params);
              navigate(
                `/contas?offset=${params.page}&limit=${params.limit_per_page}&search=${params.search}&order_column=${params.order_column}&order_type=${params.order_type}`
              );
            }}
            total={total}
            data={accountPlanCategories.map((accountPlanCategory) => {
              return {
                tr: [
                  {
                    name: accountPlanCategory.name,
                  },
                  {
                    name: accountPlanCategory.type,
                  },
                  {
                    name: accountPlanCategory.subtype,
                  },
                  {
                    name: (
                      <ButtonListButton>
                        <EditButton link={`/conta/${accountPlanCategory.id}`} />
                        {checkPermission({
                          is_admin: user.is_admin,
                          type: "Super Admin",
                        }) ? (
                          <DeleteModal
                            onDelete={(id) => {
                              setAccountPlanCategories(
                                accountPlanCategories.filter(
                                  (accountPlanCategory) =>
                                    accountPlanCategory.id !== id
                                )
                              );
                            }}
                            id={accountPlanCategory.id}
                            route="accountPlanCategories/"
                            error_message="Não foi possível remover a conta"
                            success_message="Conta removida com sucesso"
                          />
                        ) : (
                          <></>
                        )}
                      </ButtonListButton>
                    ),
                  },
                ],
              };
            })}
            columns={[
              {
                name: "name",
                label: "Nome",
                options: {
                  sort: true,
                },
              },
              {
                name: "type",
                label: "Tipo",
                options: {
                  sort: true,
                },
              },
              {
                name: "subtype",
                label: "Subtipo",
                options: {
                  sort: true,
                },
              },
              {
                name: "action",
                label: "Ações",
                options: {
                  sort: false,
                },
              },
            ]}
          />
        }
      />
    </>
  );
}
